/**
 * @internal
 */
export const getWidestContent = (textElement, length, getValue) => {
  const ctx = getContext();
  const width = {
    primary: 0,
    withSecondary: 0
  };
  let value;
  if (ctx && textElement) {
    setFontStyle(ctx, textElement);
    for (let i = 0; i < length; i++) {
      value = getValue(i);
      width.primary = Math.max(width.primary, ctx.measureText(value.primary ?? '').width + value.iconWidth);
      width.withSecondary = Math.max(width.withSecondary, width.primary + ctx.measureText(value.secondary ? ` ${value.secondary}` : '').width + value.iconWidth);
    }
  }
  return width;
};

/**
 * @internal
 */
export const measureTextWidth = (textElement, text) => {
  const ctx = getContext();
  if (ctx && textElement) {
    setFontStyle(ctx, textElement);
    return ctx.measureText(text ?? '').width;
  }
  return 0;
};
const getContext = () => document.createElement('canvas').getContext('2d');
export const getFontFamilyFromStyle = font => {
  // must be the following order of font-xxx
  return [font.fontStyle, font.fontWeight, font.fontSize, font.fontFamily].join(' ');
};
export const getFontFamily = textElement => {
  const style = window.getComputedStyle(textElement);
  // must be the following order of font-xxx
  return [style.getPropertyValue('font-style'), style.getPropertyValue('font-variant'), style.getPropertyValue('font-weight'), style.getPropertyValue('font-size'), style.getPropertyValue('font-family')].join(' ');
};
const setFontStyle = (ctx, textElement) => ctx.font = getFontFamily(textElement);
export const parseKey = key => {
  const k = key.replace(/(?!^-)^\D+/g, '');
  if (k === '') return -1;
  return parseInt(k);
};
//# sourceMappingURL=utils.js.map